import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { SearchInput, SearchResultBase } from '../../api/models/search-result';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class SearchService {

  baseUrl = environment.searchServiceBaseUrl;

  private isTesscoAdmin: boolean = false;
  private orgId: string;
  private textSearch = '';
  private page = 1;
  private productCategoryFilters: {category: string, count: number}[] = [];
  private marketFilters: { marketId: string, marketName: string, count: number }[] = [];

  private inputIndexFilters: string[] = [];
  private inputMarketFilters: string[] = [];
  private inputProductCategoryFilters: string[] = [];
  $searchSubject = new Subject<string>();
  $searchCleanSubject = new Subject<any>();

  private sortBy: string = 'Relevance';

  constructor(private http: HttpClient) { }

  queryGlobalAutoSuggestion(searchInput: SearchInput) {
    const url = `${this.baseUrl}search/getGlobalAutoSuggestion`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.post<string[]>(url, searchInput, { headers });
  }

  query(searchInput: SearchInput) {
    const url = `${this.baseUrl}search/query`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.post<SearchResultBase>(url, searchInput, { headers });
  }

  getSearchText(): string {
    return this.textSearch;
  }

  saveSearchText(text: string) {
    this.textSearch = text;
  }

  getOrgId(): string {
    return this.orgId;
  }

  saveOrgId(orgId: string) {
    this.orgId = orgId;
  }

  saveSearchPage(page: number) {
    this.page = page;
  }

  getTesscoAdmin(): boolean {
    return this.isTesscoAdmin;
  }

  saveTesscoAdmin(isTesscoAdmin: boolean) {
    this.isTesscoAdmin = isTesscoAdmin;
  }

  getSearchPage(): number {
    return this.page;
  }

  saveProductCategoryFilters(filters: {category: string, count: number}[]) {
    this.productCategoryFilters = filters;
  }

  getProductCategoryFilters(): {category: string, count: number}[] {
    return this.productCategoryFilters;
  }

  saveMarketFilters(filters: { marketId: string, marketName: string, count: number }[]) {
    this.marketFilters = filters;
  }

  getMarketFilters(): { marketId: string, marketName: string, count: number }[] {
    return this.marketFilters;
  }

  saveInputIndexFilters(filters: string[]) {
    this.inputIndexFilters = filters;
  }

  getInputIndexFilters(): string[] {
    return this.inputIndexFilters;
  }

  saveInputMarketFilters(filters: string[]) {
    this.inputMarketFilters = filters;
  }

  getInputMarketFilters(): string[] {
    return this.inputMarketFilters;
  }

  saveInputProductCategoryFilters(filters: string[]) {
    this.inputProductCategoryFilters = filters;
  }

  getInputProductCategoryFilters(): string[] {
    return this.inputProductCategoryFilters;
  }

  saveSortBy(sortBy: string) {
    this.sortBy = sortBy;
  }

  getSortBy(): string {
    return this.sortBy;
  }

  resetSearchDetails(textSearch: string) {
    this.saveSearchText(textSearch);
    this.saveSearchPage(1);
  }
  
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/services/search.service.ts